module.exports = __webpack_public_path__ + "static/media/Coins_Tex@3x.be978cc4.png";